import { getStoryDistributionForLevel as m } from "./index3.js";
import { getStoryDistributionTotals as p } from "./index4.js";
import { getStoryMetricsForLevel as v } from "./index5.js";
import { getStoryMetricsTotals as S } from "./index6.js";
import { getStoryLevelApartmentCategoryCount as f } from "./index7.js";
import { getStorySpecDistributionTotals as a } from "./index8.js";
function L(t) {
  const i = S(t), c = p(t), n = a(t), e = [], r = [], s = [], l = new Set(t.data.levels.map((o) => o.levelIndex));
  for (const o of l)
    e.push(v(t, o)), r.push(m(t, o)), s.push(f(t, o));
  return { metrics: i, levelMetrics: e, distribution: c, levelDistribution: r, specDistribution: n, levelSpecDistribution: s };
}
export {
  L as getBuildingStoryMetrics
};
//# sourceMappingURL=index2.js.map
